import React, { useState, useEffect } from "react";
import { Table, Button, Container } from 'react-bootstrap';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import style from "../Perfil/Perfil.module.css";
import { FaChevronLeft } from "react-icons/fa6";
import { formatShortDate } from "../../utils/auxiliarFunctions";
import { getActivityDates } from "../../utils";

const Fechas = () => {
  const { idActividad } = useParams();
  const [fechas, setFechas] = useState([]);

  const navigate = useNavigate();

  const getFechas = async () => {
    if (!idActividad) {
      console.error("ID de actividad no disponible.");
      return;
    }

    const fechasArray = await getActivityDates(idActividad);
    setFechas(fechasArray);
  }

  useEffect(() => {
    if (idActividad) {
      getFechas();
    } else {
      console.error("ID de actividad no disponible.");
    }
  }, [idActividad]);

  return (
    <Container className="py-4">
      <Button variant="dark" size="xs" className="primaryBtn d-flex align-items-center" onClick={() => navigate(-1)}>
        <FaChevronLeft /> Volver
      </Button>

      <h1 className="mt-4 titles">Fechas de la actividad</h1>

      {fechas.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {fechas.map((fecha, index) => {
              const formattedDate = formatShortDate(fecha);
              return(
                <tr key={index}>
                  <td>
                    <NavLink to={`/${idActividad}/${fecha}`} className={style.register}>
                      {formattedDate}
                    </NavLink>
                  </td>
                </tr>
              )
            }
            )}
          </tbody>
        </Table>
      ) : (
        <p>No hay fechas disponibles para esta actividad.</p>
      )}
    </Container>
  );
};

export default Fechas;
